<template>
  <v-sheet>
    <v-sheet class="d-flex flex-column my-10">
      <v-row
        v-for="(item, index) in contItems"
        :key="index"
        align="center"
        justify="center"
        class="flex-column flex-sm-row"
      >
        <v-col cols="12" sm="6" lg="4">
          <v-sheet
            class="ma-3 pa-5 rounded-pill"
            v-if="item.header"
            color="primary"
          >
            <strong>{{ item.header }}</strong>
          </v-sheet>
        </v-col>
        <v-col cols="12" sm="6" lg="6">
          <v-sheet class="ma-3 pa-5" v-if="item.content">
            <div v-html="item.content" class="text-center"></div>
            <!--link:urlのパラメータがあるときだけ出る-->
            <div class="text-center ma-3">
              <v-btn
                v-if="item.link1"
                text
                :href="item.link1"
                target="_blank"
                variant="tonal"
                class="pa-2 ma-1"
                color="primary"
                >THE CAFE</v-btn
              >
              <v-btn
                v-if="item.link2"
                text
                :href="item.link2"
                target="_blank"
                variant="tonal"
                class="pa-2 ma-1"
                color="primary"
                >昭和ブックカフェ</v-btn
              >
            </div>
          </v-sheet>
        </v-col>
      </v-row>
    </v-sheet>
  </v-sheet>
</template>

<script>
  export default {
    data() {
      return {
        drawer: false,
        contItems: [
          {
            header: "開催予定日",
            content: "2026年2月1日(SUN)",
          },

          {
            header: "イベント開催時間",
            content: "11時～16時",
          },
          {
            header: "入場料",
            content:
              "◆試遊・物販チケット 利用90分/300円"
          },

          // {
          //   header: "試遊・物販会場",
          //   content: "3F「THE CAFE」「昭和ブックカフェ」",
          //   link1: "https://tabaco.biz/",
          //   link2: "https://shimbashidaisuki.com/",
          // },
          {
            header: "イベント会場",
            content: "B2F「ニュー新ホール」<br>※会場にはエレベータでしか移動できません。",
            // link: "https://shimbashidaisuki.com/",
          },

          {
            header: "会場住所",
            content: "〒105-0004 東京都港区新橋2-16-1 <br/>ニュー新橋ビル",
          },
        ],
      };
    },
  };
</script>
<!-- <style scoped>
  .contenttext {
    text-align: center;
  }
</style> -->
